module.exports = __webpack_public_path__ + "static/media/Article-summary-pic-getty.e710020b.jpg";